import * as React from "react";

const SvgLine = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      id="line_svg__a"
      d="M20.327 14.87c1.229-1.53 1.823-3.488 1.64-5.39l-.025-.05-.045-.47c-.235-1.333-.89-2.613-1.897-3.702-1.03-1.115-2.37-1.995-3.88-2.548a11.96 11.96 0 00-4.131-.723c-1.931 0-3.802.451-5.412 1.306C3.553 4.9 1.765 7.816 2.025 10.725c.134 1.513.73 2.957 1.72 4.174.95 1.164 2.239 2.106 3.727 2.722.917.38 1.868.568 2.874.767l.124.024c.184.037.74.147 1.037.61.124.19.25.524.133 1.01l-.044.182c-.096.39-.18.732-.123 1.051.015.09.039.135.047.146.328-.019.906-.358 1.217-.54a36.46 36.46 0 002.828-1.874c1.609-1.16 3.434-2.477 4.762-4.128zm3.615-5.733c.28 2.465-.47 5.011-2.056 6.985-1.498 1.862-3.44 3.263-5.152 4.498-.78.561-1.813 1.287-2.918 1.936-.607.356-1.424.836-2.29.836-1.041-.002-1.835-.7-2.023-1.782a3.65 3.65 0 01.032-1.345c-.953-.19-1.87-.399-2.83-.796-1.791-.743-3.351-1.885-4.51-3.306C.952 14.634.203 12.815.034 10.903c-.331-3.712 1.87-7.392 5.606-9.377C8.942-.227 13.213-.486 16.809.832c1.805.661 3.417 1.722 4.66 3.068 1.043 1.13 1.789 2.432 2.189 3.812l.099-.009.185 1.434zM5.257 6.877v4.634h2.387v1.054H3.886V6.878h1.371zm3.059 5.688V6.878h1.367v5.687H8.316zm5.703-2.148v-3.54h1.367v5.688h-1.363l-2.016-3.54v3.54h-1.37V6.878h1.37l2.012 3.539zm2.234 2.148V6.878h3.926v1.058h-2.555v1.2h2.156v1.015h-2.156v1.36h2.547v1.054h-3.918z"
    />
  </svg>
);

export default SvgLine;
